var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('recap-resource-list',{attrs:{"recaps":_vm.recaps,"bulkActionResultItems":_vm.bulkActionResultItems,"actions":{ fetchResource: _vm.fetchResource },"options":{ hideRowSize: true }}})}
var staticRenderFns = []

export { render, staticRenderFns }